import uuid from 'react-uuid';
import { currencyFormatZeroToTwoDecimals, percentFormat, standardDecimalFormat } from 'common/formats/formats';
import { withTooltip } from 'components';
import { baseRowConfig } from 'pages/Financials/data';
import RowHeader from 'pages/Valuations/components/CompGroupRowHeader';
import { KpiConfigurationRow, KpiRowConfig } from './types';

const RowHeaderWithTooltip = withTooltip(RowHeader);

export const formatMap = {
  1: standardDecimalFormat,
  2: percentFormat({ fractionDigits: 2 }),
  3: currencyFormatZeroToTwoDecimals,
} as { [key: number]: KpiConfigurationRow['format'] };

const rowConfig: KpiRowConfig = params => {
  const { existingKpis, isDisabled } = params;
  const kpiConfig: KpiConfigurationRow[] = existingKpis.map(kpi => ({
    value: kpi.name,
    alias: kpi.alias ?? uuid(),
    hidden: false,
    readOnly: isDisabled,
    isKpiRow: true,
    kpiDataType: kpi.data_type,
    format: null, // this will actually change according to KPI type for table content cells
    gridType: 'number',
    dbType: 'string',
    allowNegativeValue: true,
    isEditableTitleCell: !isDisabled,
    valueViewer: (props: any) => <RowHeaderWithTooltip {...props} showPricingDateWarning={false} />,
  }));
  const titlesConfig = [...baseRowConfig] as KpiConfigurationRow[];
  titlesConfig[0] = {
    ...titlesConfig[0],
    rowSpan: 2,
    value: 'KPI Table',
  };

  titlesConfig[1] = {
    ...titlesConfig[1],
    className: `${titlesConfig[1].className} financial-year`,
  };

  return [titlesConfig[0], titlesConfig[1], ...kpiConfig];
};

export default rowConfig;
